import $ from 'jquery';
import Swiper from 'swiper';
import { Pagination} from 'swiper/modules';
import 'swiper/css'; 
import 'swiper/css/pagination'; 

$(function () {
    $('.listpanel .item-list a').on('click', function (evt) {
        evt.preventDefault();
        const $block = $(this).parents('.listpanel');
        const $slide = $block.find('.swiper-slide');
        const $lis = $block.find('.item-list li');

        $lis.removeClass('active');
        $slide.removeClass('active');

        $(this).parent('li').addClass('active');
        $($(this).attr('href')).addClass('active');
    });

    // Swiper for mobile
    if (Foundation.MediaQuery.current == 'small') {
        const swiper = new Swiper('.listpanel .swiper', {
            modules: [Pagination],
            pagination: {
                el: '.swiper-pagination'
            },
            spaceBetween: 16,
            slidesPerView: 1.2,
            centeredSlides: true,
            //loop:true  // This gives browser warnings due to the slidesPerView of 1.1
        });
    }
});